import { useState, ChangeEvent, FormEvent } from "react";
import { Link, useNavigate } from "react-router-dom";
import FormContainer from "../components/common/FormElements/FormContainer";
import FormFooter from "../components/common/FormElements/FormFooter";
import FormHeader from "../components/common/FormElements/FormHeader";
import Input from "../components/common/FormElements/Input";
import SubmitButton from "../components/common/FormElements/SubmitButton";
import { LoginDataType } from "../types/loginDataType";

// ** import type
import { ErrorType } from "../types/errorType";
import FormError from "../components/common/FormElements/FormError";
import { useDispatch } from "react-redux";
import { loginFunc } from "../features/auth";

const Login = () => {
  // navigate variable for navigate to another page
  const navigate = useNavigate();

  // dispatch function
  const dispatch = useDispatch();

  // loading state
  const [isLoading, setIsLoading] = useState<boolean>(false);

  // error state
  const [isError, setIsError] = useState<ErrorType>({
    errorType: "",
    errorMessage: "",
  });

  // remember me checkbox state
  const [remember, setRemember] = useState<boolean>(false);

  // credential state
  const [data, setData] = useState<LoginDataType>({
    email: "",
    password: "",
  });

  // input change handler
  const changeHandler = (e: ChangeEvent<HTMLInputElement>) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  // form submit handler
  const formHandler = (e: FormEvent<HTMLFormElement>) => {
    // prevent default form submit behavior
    e.preventDefault();

    // set all error property to empty on submit the form
    setIsError({
      errorType: "",
      errorMessage: "",
    });

    // start loading
    setIsLoading(true);
    const value = {
      email: data.email,
      password: data.password,
      remember: remember,
    };

    // if any input field is empty it will give error message under the form or go to the next step
    if (!value.email || !value.password) {
      setTimeout(() => {
        setIsLoading(false);
        setIsError({
          errorType: "error",
          errorMessage: "Please fill all the field",
        });
      }, 500);
    } else {
      dispatch(loginFunc());
      setTimeout(() => {
        setIsLoading(false);
        setIsError({
          errorType: "success",
          errorMessage: "Registration successfull!",
        });
      }, 500);
      setTimeout(() => {
        navigate("/");
      }, 1000);
    }
  };

  return (
    <FormContainer>
      <FormHeader
        labelText="Welcome to Zissanger"
        subheading={
          "Please fill all the required field for login and enjoy with your friends."
        }
      />
      <form
        className="w-full flex flex-col gap-5"
        onSubmit={(e: FormEvent<HTMLFormElement>) => formHandler(e)}
      >
        <Input
          inputType="email"
          placeholder="Your email Address"
          icon="fa-solid fa-user"
          inputName="email"
          value={data.email}
          handler={changeHandler}
        />
        <Input
          inputType="password"
          placeholder="Your password"
          icon="fa-solid fa-key"
          inputName="password"
          value={data.password}
          handler={changeHandler}
        />
        <FormFooter
          value={remember}
          setValue={setRemember}
          labelText="Remember me"
        />
        <SubmitButton buttonLabel="Sign In" isLoading={isLoading} />
        {isError.errorType && <FormError errorObject={isError} />}
      </form>
      <div className="flex justify-center w-full mt-1">
        {/* Sign Up link */}
        <div className="flex gap-1 items-center">
          <p className="text-slate-500 sm:text-sm md:text-base">
            Don't have an account?
          </p>
          <Link
            to="/registration"
            className="text-violet-500 w-max sm:text-sm md:text-base"
          >
            Sign Up
          </Link>
        </div>
      </div>
    </FormContainer>
  );
};

export default Login;
